import { log } from '../lib/logger';

const STORAGE_KEY = 'forgeview-source';

export function loadSource(): string {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      log.info('Loaded source from localStorage', { length: saved.length });
      return saved;
    }
  } catch (e) {
    log.error('Failed to load from localStorage', e);
  }
  return '';
}

export function saveSource(source: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, source);
    log.info('Saved source to localStorage', { length: source.length });
  } catch (e) {
    log.error('Failed to save to localStorage', e);
  }
}
